import React, { useEffect, useRef, useState } from "react";
import { CheckPicker, Col, InputNumber, Row, SelectPicker } from "rsuite";
import { getPricingFiltersnew } from "../../queries/apiQueries";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import { CUST_SUB_MKT } from "../../config/constants";

const Filters = (props: any) => {
	const [filterData, setFilterData] = useState<any>({
		custMarket: new Array<{ custMarket: string }>(),
		custSize: new Array<{ custSize: string }>(),
		customerSubMarket: new Array<{ customerSubMarket: string }>(),
		district: new Array<{ district: string }>(),
		salesOffice: new Array<{ salesOffice: string }>(),
		projectFlag: new Array<{ projectFlag: string }>(),
		startification: new Array<{ startification: string }>(),
	});
	const [fromTo, setFromTo] = useState({ from: 0, to: 0 });
	const [selectedFilter, setSelectedFilter] = useState<any>({
		custMarket: [],
		custSize: [],
		customerSubMarket: [],
		district: [],
		salesOffice: [],
		projectFlag: [],
		startification: [],
	});
	const dispatch = useDispatch<any>();
	const didMount = useRef(false);
	const didClean = useRef(false);
	const location = useLocation();
	const customer = new URLSearchParams(location.search).get("customer");

	const getPricingFilterData = async (payload: any = {}) => {
		let response = await dispatch(getPricingFiltersnew(selectedFilter));
		if (response) {
			let newFilterData: any = filterData;
			newFilterData.projectFlag = response.projectFlag;
			if (selectedFilter.custMarket.length === 0) {
				newFilterData.custMarket = response.custMarket;
			}
			if (selectedFilter.custSize.length === 0) {
				newFilterData.custSize = response.custSize;
			}
			if (selectedFilter.customerSubMarket.length === 0) {
				response?.customerSubMarket?.forEach((val: any) => {
					let index = CUST_SUB_MKT?.findIndex(
						(e: any) => e?.key === val?.customerSubMarket
					);
					if (index > -1) {
						val.label = CUST_SUB_MKT[index]?.value;
					}
				});
				newFilterData.customerSubMarket = response.customerSubMarket;
			}
			if (selectedFilter.district.length === 0) {
				newFilterData.district = response.district;
			}
			if (selectedFilter.salesOffice.length === 0) {
				newFilterData.salesOffice = response.salesOffice;
			}
			if (selectedFilter.startification.length === 0) {
				newFilterData.startification = response.startification;
			}
			
			setFilterData(newFilterData);
		}
	};


	useEffect(() => {
		// getPricingFilterData();
		if (
			filterData?.projectFlag?.length === 0 &&
			props?.data?.projectFlag?.length > 0
		) {
			props.data.customerSubMarket= props?.data?.customerSubMarket.filter((x:any) => x.customerSubMarket !== null);
			setFilterData(props.data);
		}
	}, [props.data]);

	useEffect(() => {
		if (props.data?.list?.length > 0) {
			if (
				(fromTo.from == 0 || fromTo.from == undefined) &&
				(fromTo.to == 0 || fromTo.to == undefined)
			) {
				setFromTo({
					from: props?.data?.minOpp,
					to: props?.data?.maxOpp,
				});
			}
		}
	}, [props.data?.list, fromTo]);

	useEffect(() => {
		if (didClean.current) {
			getPricingFilterData();
			props.handleFilterChange(selectedFilter);
			didClean.current = false;
		}
	}, [selectedFilter]);

	const handleSelectedFilter = () => {
		if (didMount.current) {
			getPricingFilterData();
			props.handleFilterChange(selectedFilter);
			didMount.current = false;
		}
	};

	useEffect(() => {
		if (customer) {
			setSelectedFilter({
				...selectedFilter,
				bill_customer_id: [customer],
			});
			didClean.current = true;
		}
	}, [customer]);

	return (
		<div
			style={{
				width: "70%",
				display: "flex",
				justifyContent: "flex-start",
			}}
		>
			<div
				className="filter-flex-custom gap-x-2"
				style={{ flexBasis: "100%" }}
			>
				<div
					className="sub-heading-text"
					style={{ minWidth: "7vw", maxWidth: "7vw" }}
				>
					<CheckPicker
						className=" projectFlag-dropdown"
						onExit={handleSelectedFilter}
						onClean={() => (didClean.current = true)}
						preventOverflow={true}
						appearance="default"
						onChange={(value: any) => {
							setSelectedFilter({
								...selectedFilter,
								projectFlag: value ? value : [],
							}),
								(didMount.current = true);
						}}
						menuStyle={{
							background: "white",
							color: "white",
							width: "auto",
							fontSize: "1em",
						}}
						placeholder=" Project Type"
						data={filterData?.projectFlag}
						labelKey="project"
						valueKey="project"
						style={{
							width: "100%",
							color: "white",
						}}
						value={selectedFilter?.projectFlag}
					/>
				</div>

				<div
					className="sub-heading-text"
					style={{ minWidth: "7vw", maxWidth: "7vw" }}
				>
					<CheckPicker
						className="customwhite custMarket-dropdown"
						onExit={handleSelectedFilter}
						onClean={() => (didClean.current = true)}
						preventOverflow={true}
						appearance="default"
						onChange={(value: any) => {
							setSelectedFilter({
								...selectedFilter,
								custMarket: value,
							}),
								(didMount.current = true);
							console.log("ccccc", selectedFilter);
						}}
						menuStyle={{
							background: "white",
							color: "white",
							width: "auto",
							fontSize: "1em",
						}}
						placeholder="Customer Market"
						data={filterData?.custMarket}
						labelKey="customerMarket"
						valueKey="customerMarket"
						style={{
							width: "100%",
							color: "white",
						}}
						value={selectedFilter?.custMarket}
					/>
				</div>

				<div
					className="sub-heading-text"
					style={{ minWidth: "7vw", maxWidth: "7vw" }}
				>
					<CheckPicker
						className="customwhite district-dropdown"
						onExit={handleSelectedFilter}
						onClean={() => (didClean.current = true)}
						preventOverflow={true}
						appearance="default"
						onChange={(value: any) => {
							setSelectedFilter({
								...selectedFilter,
								district: value,
							}),
								(didMount.current = true);
						}}
						menuStyle={{
							background: "white",
							color: "white",
							width: "auto",
							fontSize: "1em",
						}}
						placeholder="Sales District"
						data={filterData?.district}
						labelKey="district"
						valueKey="district"
						style={{
							width: "100%",
							color: "white",
						}}
						value={selectedFilter?.district}
					/>
				</div>

				<div
					className="sub-heading-text"
					style={{ minWidth: "7vw", maxWidth: "7vw" }}
				>
					<CheckPicker
						className="customwhite salesOffice-dropdown"
						onExit={handleSelectedFilter}
						onClean={() => (didClean.current = true)}
						preventOverflow={true}
						appearance="default"
						onChange={(value: any) => {
							setSelectedFilter({
								...selectedFilter,
								salesOffice: value,
							}),
								(didMount.current = true);
						}}
						menuStyle={{
							background: "white",
							color: "white",
							width: "auto",
							fontSize: "1em",
						}}
						placeholder="Sales Office"
						data={filterData?.salesOffice}
						labelKey="SALES_OFFICE_VKBUR"
						valueKey="SALES_OFFICE_VKBUR"
						style={{
							width: "100%",
							color: "white",
						}}
						value={selectedFilter?.salesOffice}
					/>
				</div>

				<div
					className="sub-heading-text"
					style={{ minWidth: "7vw", maxWidth: "7vw" }}
				>
					<CheckPicker
						className="customwhite custSize-dropdown"
						onExit={handleSelectedFilter}
						onClean={() => (didClean.current = true)}
						preventOverflow={true}
						appearance="default"
						onChange={(value: any) => {
							setSelectedFilter({
								...selectedFilter,
								custSize: value,
							}),
								(didMount.current = true);
						}}
						menuStyle={{
							background: "white",
							color: "white",
							width: "auto",
							fontSize: "1em",
						}}
						placeholder="Customer Size"
						data={filterData?.custSize}
						labelKey="customerSize"
						valueKey="customerSize"
						value={selectedFilter?.custSize}
						style={{
							width: "100%",
							color: "white",
						}}
					/>
				</div>

				<div
					className="sub-heading-text"
					style={{ minWidth: "7vw", maxWidth: "7vw" }}
				>
					<CheckPicker
						className="customwhite startification-dropdown"
						onExit={handleSelectedFilter}
						onClean={() => (didClean.current = true)}
						preventOverflow={true}
						appearance="default"
						onChange={(value: any) => {
							setSelectedFilter({
								...selectedFilter,
								startification: value,
							}),
								(didMount.current = true);
						}}
						menuStyle={{
							background: "white",
							color: "white",
							width: "auto",
							fontSize: "1em",
						}}
						placeholder="Startification Quad.."
						data={filterData?.startification}
						labelKey="stratification"
						valueKey="stratification"
						style={{
							width: "100%",
							color: "white",
						}}
						value={selectedFilter?.startification}
					/>
				</div>

				<div
					className="sub-heading-text"
					style={{ minWidth: "7vw", maxWidth: "7vw" }}
				>
					<CheckPicker
						className="customwhite customerSubMarket-dropdown"
						onExit={handleSelectedFilter}
						onClean={() => (didClean.current = true)}
						preventOverflow={true}
						appearance="default"
						onChange={(value: any) => {
							setSelectedFilter({
								...selectedFilter,
								customerSubMarket: value,
							}),
								(didMount.current = true);
						}}
						menuStyle={{
							background: "white",
							color: "white",
							width: "auto",
							fontSize: "1em",
						}}
						placeholder="Customer Subm.."
						data={filterData?.customerSubMarket}
						labelKey="label"
						valueKey="customerSubMarket"
						style={{
							width: "100%",
							color: "white",
						}}
						value={selectedFilter?.customerSubMarket}
					/>
				</div>
			</div>
		</div>
	);
};

export default Filters;
